import { useFormContext } from 'react-hook-form'

import { useFetchDictionariesByCategoryCodeQuery } from '@redux/api'

import { CATEGORIES } from '@constants'

export const useAction = ({
  sectionIndex,
  tabIndex,
  actionIndex,
}: {
  sectionIndex: number
  tabIndex: number
  actionIndex: number
}) => {
  const { watch } = useFormContext()

  const { data: typesWindowActions } = useFetchDictionariesByCategoryCodeQuery(
    CATEGORIES.BINDING_WINDOW_ACTION
  )

  const actionOptions = typesWindowActions
    ? typesWindowActions.map(action => {
        return {
          label: action.title,
          id: action.code,
        }
      })
    : []

  const watchActionTitle = watch(
    `sections.${sectionIndex}.tabs.${tabIndex}.actions.${actionIndex}.actionTitle`
  )

  return {
    state: {},
    handlers: {},
    data: { watchActionTitle, actionOptions },
  }
}
